<template>
	<v-dialog persistent @click:outside="closeDialog()" v-model="dialog" scrollable max-width="700" content-class="test-class">
		<v-form ref="form" @submit.prevent="validate">
			<v-card >
				<v-card-title>
					{{ title }}
					<v-btn icon @click="closeDialog()" class="ml-auto">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="py-3">
					<template v-if="!fields.user">
						<label :key="validationKey + 1" :class="{'error--text': validated && errors && errors.user}" class="bold">{{ $vuetify.lang.t('$vuetify.views.wall.kudos.chooseUser') }}</label>
						<search-user class="mt-2" ref="searchUser" @selected="setUser"/>
					</template>
					<div v-else class="d-flex flex-row align-items-center">
						<avatar :user="fields.user" sm class="mr-2" /> {{ fields.user.name || fields.user.email }} <v-btn icon @click="setUser(null)"><v-icon>mdi-close</v-icon></v-btn>
					</div>

					<v-row class="mt-5 relative">
						<v-overlay
							v-if="loading.kudos"
							:value="true"
							absolute
							:dark="false"
							light
							color="white"
							opacity="0.8"
						>
							<v-progress-circular
								indeterminate
								size="50"
							></v-progress-circular>
						</v-overlay>

						<v-col cols="12"  class="py-0">
							<label for="attach-kudos__user-search" :key="validationKey" :class="{'error--text': validated && errors && errors.type}" class="bold">Wybierz typ</label>
						</v-col>
						<v-col v-for="(type, index) in kudosTypes" :key="index + type.id" cols="6">
							<v-card @click="setType(type)" :class="{'active-type': fields.typeId == type.id}"  class="clickbale bg-white shadow" >
								<v-img max-height="150" min-height="150" :src="type.image" />
								<v-card-text class="text-center bold">
									<div class="bold font-16 type-name">{{ type.content  }}</div>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
					<div class="mt-5">
						<v-switch v-model="showText" @change="changeContent" label="Chcę dodać własny tekst"></v-switch>
					</div>
					<div v-if="showText" class="mt-3">
						<v-textarea
							ref="textarea"
							outlined
							elevation="0"
							:placeholder="$vuetify.lang.t('$vuetify.views.wall.kudos.contentPlaceholder')"
							v-model="fields.content"
							:rules="[rules.required]"
							auto-grow
						></v-textarea>
					</div>
				</v-card-text>
				<v-card-actions class="justify-content-right py-7 px-5">
					<v-btn color="light" elevation="0" @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.goBack') }}</v-btn>
					<v-btn color="accent" elevation="0" type="submit">{{ $vuetify.lang.t('$vuetify.views.wall.kudos.summary') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import SearchUser from '@/components/search/SearchUser';
import Avatar from '@/components/Avatar'
import {mapGetters} from 'vuex';
export default {
	components: {
		'search-user': SearchUser,
		'avatar': Avatar
	},
	props: {
		edit: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: {
				kudos: false
			},
			key: 0,
			dialog: false,
			fields: {
				typeId: null,
				user: null,
				// type: null,
				content: '',
				image: null
			},
			showText: false,
			errors: {},
			validated: false,
			validationKey: 0,
			rules: {
				required: value => !!value || 'Pole wymagane.',
				content: value => {
					if(this.showText) {
						if(value) {
							return true
						}
						return 'Pole wymagane'
					}
				}
			},
		}
	},
	computed: {
		...mapGetters({
			kudosTypes: 'dictionaries/kudosTypes'
		}),
		title() {
			if(!this.edit) {
				return this.$vuetify.lang.t('$vuetify.views.wall.kudos.addKudos')
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.kudos.editKudos')
		},
		selectedType() {
			if(this.fields.typeId) {
				return this.kudosTypes.find(x => x.id == this.fields.typeId)
			}
			return null;
		}
	},
	methods: {
		changeContent() {
			if(!this.showText) {
				this.fields.content = this.selectedType.content;
			}
		},
		setUser(user) {
			this.fields.user = user;
			if(user) {
				this.errors.user = null
			}
			else {
				this.errors.user = "Wybierz użytkownika"
			}
		},
		setType(type) {
			console.log("TYPE", type)
			if(type) {
				this.fields.typeId = type.id;
				this.fields.content = type.content;
				this.fields.image = type.image;
				this.errors.type = null;
				this.validationKey++;
			}
		},
		showDialog() {
			this.dialog = true;
		},
		setKudos(kudos) {
			if(kudos) {
				this.fields = {
					typeId: kudos.typeId || null,
					user: kudos.user || null,
					// type: null,
					content: kudos.content || '',
					image: kudos.image || null
				};
				if(this.selectedType && kudos.content) {
					if(this.selectedType && this.selectedType.content != kudos.content) {
						this.showText = true;
					}
				}

			}
			this.showDialog();
		},
		closeDialog() {
			this.dialog = false;
			this.$emit('closed');
		},
		validate() {
			// TODO: Set user
			this.validated = false;
			this.errors.type = null;
			let valid = this.$refs.form.validate();
			if(!this.fields.typeId) {
				this.errors.type = 'Wybierz typ'
			}
			if(!this.fields.user) {
				this.errors.user = 'Wybierz użytkownika'
			}
			this.validationKey++;
			this.validated = true;
			if(valid && !this.errors.type && !this.errors.user) {
				this.save();
			}
			else {
				this.$snackbar.error("Wypełnij wymagane pola");
			}
		},
		save() {
			this.$emit('selected', this.fields);
			this.dialog = false;
		}
	},
	async mounted() {
		if(!this.kudosTypes.length) {
			this.loading.kudos = true;
			await this.$store.dispatch('dictionaries/getKudosTypes');
			this.loading.kudos = false;
		}
	}
}
</script>

<style lang="scss" scoped>
	.active-type {
		.type-name {
			color: var(--v-accent-base) !important;
		}
		background: var(--v-accent-lighten1);
	}
</style>
